/**
 * H2C Backend
 * An ASP.NET Core Web API for managing H2C User 
 *
 * The version of the OpenAPI document: V40:2026_08_27_13_13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { TGetMailSwitchesDTO } from '../model/models';
import { TPutMailSwitchesDTO } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface EMailServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     */
    apiEMailGet(extraHttpRequestParams?: any): Observable<TGetMailSwitchesDTO>;

    /**
     * 
     * 
     * @param tPutMailSwitchesDTO 
     */
    apiEMailPut(tPutMailSwitchesDTO?: TPutMailSwitchesDTO, extraHttpRequestParams?: any): Observable<{}>;

}
